import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router'
import { useMe } from '@/api/hooks'
import { Loading, QueryError } from '@/components/ui/states'
import { safeNext } from '@/lib/next'

export function loginPath(next: string) {
  return next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`
}

/** Anonymous visitors go to /login?next=… */
export function RequireAuth() {
  const me = useMe()
  const location = useLocation()
  if (me.isPending) return <Loading />
  if (me.isError) return <QueryError error={me.error} onRetry={() => void me.refetch()} />
  if (!me.data) return <Navigate to={loginPath(location.pathname + location.search)} replace />
  return <Outlet />
}

/** Signed-in people skip the auth screens. */
export function PublicOnly() {
  const me = useMe()
  const [params] = useSearchParams()
  if (me.isPending) return <Loading />
  if (me.data) return <Navigate to={safeNext(params.get('next'))} replace />
  return <Outlet />
}
